import formField from 'framework/components/hoc/formField';
import TagsFieldPrimitive from './TagsField';

export default formField(TagsFieldPrimitive);
